define("shared/components/shared/expandable-radio-card-group", ["exports", "@ember/component", "@ember/object", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _object, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <fieldset
    data-test-id="expandable-radio-card-group"
    name={{@name}}
    role="radiogroup"
    {{did-insert this.addEventListeners}}
    ...attributes
  >
    {{yield}}
  </fieldset>
  */
  {
    "id": "3a6PjoeB",
    "block": "[[[11,\"fieldset\"],[24,\"data-test-id\",\"expandable-radio-card-group\"],[16,3,[30,1]],[24,\"role\",\"radiogroup\"],[17,2],[4,[38,0],[[30,0,[\"addEventListeners\"]]],null],[12],[1,\"\\n  \"],[18,3,null],[1,\"\\n\"],[13]],[\"@name\",\"&attrs\",\"&default\"],false,[\"did-insert\",\"yield\"]]",
    "moduleName": "shared/components/shared/expandable-radio-card-group.hbs",
    "isStrictMode": false
  });
  let ExpandableRadioCardGroupComponent = _exports.default = (_class = class ExpandableRadioCardGroupComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _defineProperty(this, "radioButtonGroup", null);
      _defineProperty(this, "dispatchSynchronizeEvent", () => {
        const inputs = document.getElementsByName(this.args.name);
        inputs.forEach(input => input.dispatchEvent(new Event('synchronize-radio-card-group')));
      });
    }
    addEventListeners(radioButtonGroup) {
      this.radioButtonGroup = radioButtonGroup;
      radioButtonGroup.addEventListener('change', this.dispatchSynchronizeEvent);
    }
    willDestroy() {
      super.willDestroy();
      this.radioButtonGroup?.removeEventListener('change', this.dispatchSynchronizeEvent);
    }
  }, (_applyDecoratedDescriptor(_class.prototype, "addEventListeners", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "addEventListeners"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, ExpandableRadioCardGroupComponent);
});